<i18n lang="yaml">
  pt:
    cancel: "Cancelar"
    confirm: "Confirmar"
    warning-text: "Tem certeza?"
</i18n>

<template>
  <Modal
    :id="id"
    disable-teleport
    @modal-status="status => handleCloseFromModal(status)"
  >
    <template #modal-title>
      {{ modalTitle || $t('confirm') }}
    </template>

    <template #modal-content>
      <div class="actionconfirm">
        <div class="actionconfirm__wrapper">
          <slot>
            <h4 class="actionconfirm__text text-center px-1 mx-0 mt-4">
              {{ warningText ?? $t('warning-text') }}
            </h4>
          </slot>

          <div
            data-grid
            class="actionconfirm__buttoncontainer mt-10"
          >
            <DefaultButton
              class="actionconfirm__cancel text-uppercase mx-auto"
              @click="rejectFn?.()"
            >
              {{ cancelText ?? $t('cancel') }}
            </DefaultButton>

            <DefaultButton
              :busy="busy"
              class="actionconfirm__confirmbutton growing-effect text-uppercase mx-auto"
              @click="resolveFn?.()"
            >
              {{ confirmText ?? $t('confirm') }}
            </DefaultButton>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { defineComponent } from 'vue'

import Modal from '../grid/modal'
import DefaultButton from './Button'

export default defineComponent({
  name: 'ModalConfirmAction',

  components: {
    Modal,
    DefaultButton
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  emits: ['modal-confirm-status'],

  data () {
    return {
      busy: false,

      modalTitle: null,
      cancelText: null,
      warningText: null,
      confirmText: null,

      rejectFn: null,
      resolveFn: null
    }
  },

  methods: {
    updateModalContent ({ modalTitle, confirmText, cancelText, warningText }) {
      this.modalTitle = modalTitle
      this.confirmText = confirmText
      this.cancelText = cancelText
      this.warningText = warningText
    },

    handleCloseFromModal (status) {
      if (!status && typeof this.rejectFn === 'function') {
        this.rejectFn()

        this.resolveCallback()
      }
    },

    dismissModal () {
      this.emitter.emit('toggle-modal', this.id, 0)
    },

    resolveCallback () {
      this.busy = false

      this.rejectFn = null
      this.resolveFn = null

      this.dismissModal()
    },

    confirmAction (updatedModalContent) {
      const { resolveCallback } = this

      this.updateModalContent(updatedModalContent)

      this.emitter.emit('toggle-modal', this.id, 1)

      return new Promise((resolve, reject) => {
        this.rejectFn = function () {
          resolveCallback()

          reject(new Error('user has cancelled the request'))
        }

        this.resolveFn = function () {
          this.busy = true

          resolve(resolveCallback)
        }
      })
    }
  }
})
</script>

<style lang="scss" scoped>
  .actionconfirm {
    width: 292px;

    &__text {
      color: rgb(var(--black1));
      font: 400 1.6rem "Nunito", sans-serif;

      .is-dark-theme & {
        color: rgb(var(--gray6));
      }
    }

    &__buttoncontainer {
      gap: 12px;
    }

    &__cancel,
    &__confirmbutton {
      height: 42px;
      font: 700 1.2rem "Nunito", sans-serif;
    }

    &__confirmbutton {
      width: 292px;
      background-color: red;
    }

    &__cancel {
      text-decoration: underline;
      background-color: transparent !important;
      color: rgb(var(--gray13));
    }
  }
</style>
